@if(isBrowser){
<carousel
  [loop]="true"
  [height]="carouselProductsHeight"
  [autoplay]="false"
  [arrows]="!isMobile && products.length > 7"
  class="as-row"
  [margin]="10"
  [cellWidth]="carouselProductsWidth"
>
  <app-product-card
    class="carousel-cell"
    *ngFor="let product of products"
    [product]="product"
  >
  </app-product-card>
</carousel>
}
